<ng-template #popContent>
    @if (schemaPopupInfo) {
    <div class="d-flex p-0 popover-template" [ngStyle]="{ 'border-color': getColor() }">
        <div class="event-icons-wrapper">
            <!-- virkesorderStatusIcon -->
            <i class="far fa-sm" aria-hidden="true"
                [class]="virkesOrderStatusIcon.icon"
                [style.color]="virkesOrderStatusIcon.color"></i>
            <br />
            <!-- valsStatusIcon -->
            @if (isValsSynkroniseringsFel) {
            <i
                class='fas fa-xs fa-paper-plane details-icon table-cell-icon-error'></i>
            }
            <!-- affarsform -->
            @if (isVirkeskop) {
            <i
                class="fal fa-sm fa-handshake" aria-hidden="true"></i>
            }
            <!-- tags -->
            @if (dateError) {
            <i
                class="far fa-sm fa-exclamation-triangle rask-danger"
                aria-hidden="true"></i>
            }
        </div>
        <div class="event-text-wrapper">
            <div class="event-text">
                <!-- arbetsorder-ikon -->
                @if (schemaPopupInfo.arbetsorderIkon) {
                <rask-arbetsorder-info-icon
                    [forceImageUrl]="schemaPopupInfo.arbetsorderIkon"></rask-arbetsorder-info-icon>
                }
                <!-- arbetsOrderNamn -->
                <a [routerLink]="['/planera', arbetsorderId]">{{namn}}</a>&nbsp;<span
                    class="arbetsorder-beteckning">{{arbetsorderBeteckning}}</span>
                <!-- skordarPrestation -->
                <span class="scheduler-prestation">{{prestation | number: '1.0-0'}}/dag</span>
                <br />
                <div class="volym-row">
                    <rask-textmultiline label="Planerad" [value]="parseDecimal(schemaPopupInfo.planeradVolym)"
                        [ultraTightLabel]="true" [boldText]="true"></rask-textmultiline>
                    <rask-textmultiline label="Skördad"
                        [value]="parseDecimal(schemaPopupInfo.skordadVolym) + ' (' + skordadVolymPerPlanerad + '%)'"
                        [ultraTightLabel]="true" [boldText]="true"></rask-textmultiline>
                    <rask-textmultiline label="Skotad" [value]="parseDecimalsNotGrot(schemaPopupInfo.skotadVolym, 0)"
                        [ultraTightLabel]="true" [boldText]="true"></rask-textmultiline>
                    <rask-textmultiline label="Lastad" [value]="parseDecimalsNotGrot(schemaPopupInfo.lastadVolym, 0)"
                        [ultraTightLabel]="true" [boldText]="true"></rask-textmultiline>
                    <rask-textmultiline label="Medelstam" [value]="parseDecimalsNotGrot(schemaPopupInfo.medelstam, 2)"
                        [ultraTightLabel]="true" [boldText]="true"></rask-textmultiline>
                </div>
                <hr class="hr">
                <div class="tradslag-row">
                    <rask-textmultiline label="TT" [value]="parseDecimal(schemaPopupInfo.tallTimmer)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="GT" [value]="parseDecimal(schemaPopupInfo.granTimmer)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="KTT" [value]="parseDecimal(schemaPopupInfo.klenTimmerTall)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="KGT" [value]="parseDecimal(schemaPopupInfo.klenTimmerGran)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="B-MAV" [value]="parseDecimal(schemaPopupInfo.barrmassaved)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="L-MAV" [value]="parseDecimal(schemaPopupInfo.lovmassaved)"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="SKOG" [value]="schemaPopupInfo.tillganglighetSkog"
                        [ultraTightLabel]="true"></rask-textmultiline>
                    <rask-textmultiline label="VÄG" [value]="schemaPopupInfo.tillganglighetVag"
                        [ultraTightLabel]="true"></rask-textmultiline>
                </div>
                <div class="popover-footer d-flex">
                    @if (!schemaPopupInfo?.isGrot) {
                    <div class="skordning">
                        @if (isSkordningAvslutad) {
                        <b>SKÖRDNING AVSLUTAD {{ schemaPopupInfo.skordningAvslutadDatum |
                            date:'yyyy-MM-dd' }}</b>
                        }
                        @if (isSkordningPaborjad) {
                        <b>SKÖRDNING PÅBÖRJAD {{ schemaPopupInfo.skordningPaborjadDatum |
                            date:'yyyy-MM-dd' }}</b>
                        }
                        @if (hasSkordningNotStarted) {
                        <b>SKÖRDNING EJ PÅBÖRJAD</b>
                        }
                    </div>
                    }
                    <div class="status-ikoner">
                        <rask-arbetsorder-status-ikoner
                            [arbetsorderStatusIcons]="arbetsorderStatusIcons"
                            [arbetsorderValsSynkroniseringstatus]="arbetsorderValsSynkroniseringstatus"
                            [restriktionEjKlar]="restriktionEjKlar"
                            [restriktionHanterad]="restriktionHanterad"
                            [showSpinner]="showSpinner$"
                            [showViol3Spinner]="showViol3Spinner$"
                            [virkeskopIcon]="virkeskopIcon$"
                            [viol3Icon]="viol3Icon$">
                        </rask-arbetsorder-status-ikoner>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</ng-template>

<div [ngbPopover]="popContent" container="body" triggers="manual" placement="bottom top end start"
    popoverClass="arbetsorder-scheduler-popover-ngx">
</div>